import React from "react";
import { Phone, MapPin, Mail, Instagram, Facebook, Youtube } from "lucide-react";
import Logo from "./Logo";
import { brand, courses } from "../mock";

export default function Footer() {
  return (
    <footer className="border-t border-black/5 bg-[#0A1740] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3">
            <Logo size={40} />
            <div>
              <div className="font-extrabold text-white">CYA <span className="gold-text">Youth Academy</span></div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-white/60">{brand.location}</div>
            </div>
          </div>
          <p className="mt-4 text-sm text-white/70 leading-relaxed">
            {brand.tagline}. A skill hub for young India — music, language, tech and career.
          </p>
          <div className="mt-5 flex gap-3">
            {[Instagram, Facebook, Youtube].map((I, i) => (
              <a
                key={i}
                href="#"
                className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-white/80 hover:text-[#F59E0B] hover:border-[#F59E0B]/60 transition-colors"
              >
                <I size={16} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <div className="text-white font-bold">Courses</div>
          <ul className="mt-4 space-y-2 text-sm">
            {courses.map((c) => (
              <li key={c.id}>
                <a href="#courses" className="text-white/65 hover:text-[#FBBF24] transition-colors">
                  {c.title}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-white font-bold">Company</div>
          <ul className="mt-4 space-y-2 text-sm">
            {["About", "Why Us", "Testimonials", "FAQ", "Careers"].map((x) => (
              <li key={x}>
                <a href="#" className="text-white/65 hover:text-[#FBBF24] transition-colors">{x}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-white font-bold">Reach Us</div>
          <ul className="mt-4 space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-2"><Phone size={15} className="mt-0.5 text-[#FBBF24]" /> {brand.phone}</li>
            <li className="flex items-start gap-2"><Mail size={15} className="mt-0.5 text-[#FBBF24]" /> {brand.email}</li>
            <li className="flex items-start gap-2"><MapPin size={15} className="mt-0.5 text-[#FBBF24]" /> {brand.address}</li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
        <div>© {new Date().getFullYear()} CYA Youth Academy, Vizianagaram. All rights reserved.</div>
        <div className="flex gap-4">
          <a href="#" className="hover:text-[#FBBF24]">Privacy</a>
          <a href="#" className="hover:text-[#FBBF24]">Terms</a>
        </div>
      </div>
    </footer>
  );
}
